import * as React from 'react';
export const codeSvg = React.forwardRef(function codeSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.365 1.639a.85.85 0 1 1 1.67.323l-2.4 12.4a.85.85 0 1 1-1.67-.323l2.4-12.4ZM5.2 3.399a.85.85 0 0 1 0 1.202L1.803 8l2.8 2.799A.85.85 0 0 1 3.398 12L.395 8.997A1.35 1.35 0 0 1 0 8.043v-.086c0-.358.142-.701.395-.955L4 3.4a.85.85 0 0 1 1.202 0ZM11.399 4a.85.85 0 0 1 1.202 0l3.003 3.003c.254.253.396.596.396.954v.086c0 .358-.142.701-.396.955L12.002 12.6a.85.85 0 1 1-1.202-1.202L14.198 8l-2.799-2.799a.85.85 0 0 1 0-1.202Z',
    }),
  );
});
codeSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var code = {
  category: 'icon',
  colorable: true,
  name: 'code',
  svg: codeSvg,
};
